import React, { Component } from 'react';
import PropTypes from 'prop-types';
import oget from 'oget';

export default
class TimedRow extends Component {
    static propTypes = {
        groupNumber: PropTypes.number.isRequired,
        style: PropTypes.object.isRequired,
        colors: PropTypes.object.isRequired,
        athlete: PropTypes.object.isRequired,
        data: PropTypes.object.isRequired,
        columns: PropTypes.object.isRequired,
        onRowRef: PropTypes.func.isRequired
    }

    render() {
        const {
            groupNumber,
            rowNumber,
            style,
            noStyle,
            nameStyle,
            scoreStyle,
            colors,
            columns,
            athlete,
            data,
            onRowRef
        } = this.props;

        const info = oget(
            athlete,
            'details.ColumnInformation.values[0].Value'
        );

        return (
            <div
                key={`leaderboard_timed_row_${groupNumber}_${rowNumber}`}
                className="row row-timed"
                style={style}
                ref={ref => onRowRef(
                    ref,
                    this.props
                )}
            >
                <div
                    className="cell cell-no"
                    style={noStyle}
                >
                    {data.rank}
                </div>

                {columns.Bib &&
                    <div className="cell cell-bib">
                        {data.bib}
                    </div>
                }

                <div className="cell cell-name">
                    <div style={nameStyle}>
                        {athlete.fullName}
                        {columns.Nation &&
                        <div className="nation">
                            {athlete.nationality}
                        </div>
                        }
                    </div>
                </div>

                <div
                    className="cell cell-scores"
                    style={rowNumber > 0
                        ? colors.scores.runnersUp
                        : {}
                    }
                >
                    <div
                        className="score-item"
                        style={scoreStyle}
                    >
                        {info}
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/Home/table/TableLeaderboard/timed/Row.js